import { lazy } from 'react';

export const lazyWithDelay = (importFunc) => lazy(() => {
  return Promise.all([
    importFunc,
    new Promise(resolve => setTimeout(resolve, 300))
  ])
    .then(([moduleExports]) => moduleExports);
});
